export const PAYROLL_TABLE_COLS = [
  { id: "user", label: "Delivery Associate", hasSort: true, tableNumber: 1},
  { id: "badge", label: "Badge", hasSort: true, tableNumber: 2},
  { id: "station", label: "Station", hasSort: true, tableNumber: 2},
  { id: "agency", label: "Agency", hasSort: true, tableNumber: 2},
  { id: "date", label: "Date", hasSort: true, tableNumber: 2},
  { id: "role", label: "Role", hasSort: true, tableNumber: 2},
  { id: "number_of_hours", label: "Hours", hasSort: false, tableNumber: 2},
  { id: "rate", label: "Hourly Rate", hasSort: false, tableNumber: 2},
  { id: "da_pay", label: "DA Pay", hasSort: false, tableNumber: 2},
  { id: "agency_pay", label: "Agency Pay", hasSort: false, tableNumber: 2},
  { id: "note", label: "Note", hasSort: false, tableNumber: 2},
];
